/* globals Tour, angular, _, $ */
(function() {
  'use strict';

  function EncomendaAdicionarCtrl (
    $stateParams,
    $location,
    $uibModal,
    $scope,
    $window,
    $state,
    $filter,
    $document,
    Encomenda,
    localStorageService,
    Endereco,
    Perfil,
    Pedido,
    IntegrationService
  ) {

    var vmAdd = this;
    vmAdd.alerts = [];

    function addAlert(msg, type) {
      vmAdd.alerts.push({ msg: msg, type: type });
    }

    vmAdd.closeAlert = function(index) {
      vmAdd.alerts.splice(index, 1);
    };

    if ($stateParams.errorToken) {
      addAlert(
        'O token de integração com do Bling é inválido. ' +
        'Por favor, entre em contato com a Mandaê.', 'danger'
      );
    }

    Pedido.ultimaIncompleta().then(function(pedido){
      vmAdd.pedido = pedido;
    }).catch(function(err){
      vmAdd.pedido = { remessas: [] };
    });


    function constroiModalConfirmacao() {
      localStorage.removeItem('confirmarEndereco_end');
      localStorage.removeItem('confirmarEndereco_current_step');

      function hasEtiqueta(endereco) {
        if (endereco) {
          return '<div class="address-item-data">' +
            '<h4 class="item-title">Endereço exibido na etiqueta de envio</h4>' +
            '<h5 class="item-name">' +
            Perfil.getCacheUserData().enderecos[0].etiqueta.remetente +
            '</h5><p class="item-data">' + endereco + '</p></div>';
        }
      }

      var endereco = $filter('enderecoJS')(Perfil.getCacheUserData().enderecos[0], true);
      var enderecoEtiqueta = (function() {
        if (Perfil.getCacheUserData().enderecos[0] && Perfil.getCacheUserData().enderecos[0].etiqueta) {
          return hasEtiqueta($filter('enderecoJS')(Perfil.getCacheUserData().enderecos[0].etiqueta, true));
        } else {
          return '';
        }
      })();
      var flag = true;
      // Instance the simulassao
      function getTourElement(tour) {
        confirmarEndereco.setCurrentStep(0);
        return tour.backdrop.$element[0];
      }

      var confirmarEndereco = new Tour({
        name: 'confirmarEndereco',
        steps: [{
          element: '#menu-item-perfil',
          title: 'Novidades Mandaê!',
          content: 'Olá ' + Perfil.getCacheUserData().nome +
            ', agora você pode gerenciar os dados de sua conta de um jeito mais fácil.',
          placement: 'right',
          template: '<div class="popover tour tour-total tour-confirmacao"><div class="arrow"></div>' +
            '<h3 class="popover-title text-purple"></h3><div class="popover-content"></div>' +
            '<h3 class="popover-subtitulo">Confirme seu endereço</h3>' +
            '<div class="address-item-data"><h4 class="item-title">Endereço de coleta</h4><h5 class="item-name">' +
            Perfil.getCacheUserData().enderecos[0].remetente + '</h5><p class="item-data">' + endereco +
            '</p></div>' + enderecoEtiqueta + '<div class="popover-navigation">' +
            '<button class="btn" data-role="next">Alterar</button>' +
            '<button class="btn btn-success" data-role="end">Confirmar</button></div></div>',
        }, {}],
        backdrop: true,
        backdropPadding: 2,
        orphan: '#menu-item-perfil',
        onShown: function(tour) {
          var stepElement = getTourElement(tour);
          $(stepElement).after($('.tour-step-background'));
          $(stepElement).after($('.tour-backdrop'));
        },
        onNext: function() {
          $state.go('perfil.endereco', { origem: 'pedido.encomenda.adicionar' });
          flag = false;
          confirmarEndereco.end();
        },
        onEnd: function() {
          if (flag) {
            Endereco.activateAddress(Perfil.getCacheUserData().enderecos[0].id)
              .then(function() {
                Perfil.getUserData(true)
                  .then(Pedido.redirecionar());
              });
          }
          $('.tour-backdrop, .tour-step-background').remove();
        }
      });

      confirmarEndereco.start();
    }

    // parametro força ida ao back
    Perfil
      .getActiveAddress(true)
      .then(function(enderecoAtivo) {
        if (enderecoAtivo) {
          return;
        } else {
          constroiModalConfirmacao();
          // confirmarEndereco.init();
        }
      })
      .catch(function(err) {
        console.log(err);
      });

    // Encomenda.setEncomenda({}); // REMOVIDO: estava limpando dados durante o cadastro

    function loadDadosUrl() {
      var nome = $location.search().nome;
      var cep = $location.search().cep;
      var rua = $location.search().rua;
      var numero = $location.search().numero;
      var complemento = $location.search().complemento;
      var bairro = $location.search().bairro;
      var cidade = $location.search().cidade;
      var uf = $location.search().uf;

      var encomenda = {};
      var destinatario = {};
      var endereco = {};

      encomenda.destinatario = destinatario;
      encomenda.destinatario.endereco = endereco;

      if (nome) {
        encomenda.destinatario.nome = nome;
      }
      if (cep) {
        encomenda.destinatario.endereco.cep = cep.replace('-', '');
      }
      if (rua) {
        encomenda.destinatario.endereco.logradouro = rua;
      }
      if (numero) {
        encomenda.destinatario.endereco.numero = numero;
      }
      if (complemento) {
        encomenda.destinatario.endereco.complemento = complemento;
      }
      if (bairro) {
        encomenda.destinatario.endereco.bairro = bairro;
      }
      if (cidade) {
        encomenda.destinatario.endereco.cidade = cidade;
      }
      if (uf) {
        encomenda.destinatario.endereco.uf = uf;
      }

      if (rua || numero || complemento || bairro || cidade || uf) {
        vmAdd.$parent.isCepPreenchido = true;
        vmAdd.$parent.podeEscolherFormaEnvio = true;
      }

      Encomenda.setEncomenda(encomenda);
    }

    // Carrega os parametros da URL no form, se existirem.
    loadDadosUrl();

    vmAdd.exibirModalMl = function() {
      $uibModal.open({
        animation: false,
        windowClass: 'modal-mercado-livre',
        template: require('../../common/integration-popover/mercado-livre.html'),
        controller: 'ModalMercadoLivreCtrl as vmML',
        resolve: {
          primeiraVez: false
        }
      });
    };

  }

  function ModalMercadoLivreCtrl ($uibModalInstance) {
    var vmML = this;
    vmML.calc = {};
    vmML.tamanho = null;
    vmML.calcularTamanhoCaixa = function (dadosTamanhoCaixa) {
      if (dadosTamanhoCaixa.$valid) {
        vmML.tamanho = null;
        var cmCubicos = vmML.calc.comprimento * vmML.calc.altura * vmML.calc.largura;
        if (cmCubicos < 25000) {
          vmML.tamanho = 'pequeno até 25.000';
        } else if (cmCubicos < 50000) {
          vmML.tamanho = 'médio até 50.000';
        } else {
          vmML.tamanho = 'grande até 150.000';
        }
      }
    };

    vmML.fechar = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }

  angular
    .module('mandaeApp')
    .controller('EncomendaAdicionarCtrl', EncomendaAdicionarCtrl)
    .controller('ModalMercadoLivreCtrl', ModalMercadoLivreCtrl);

})();
